import { observable, action, reaction } from 'mobx';
import { setter } from 'mobx-decorators';
import Permissions from '../services/enums/permissions';

class RoutesStore {

    @observable selectedTab;
    @observable selectedTabId = 1;
    @setter @observable settingsSelectedTabId;
    @setter @observable securitySelectedTab;
    @setter @observable generalSettingsSelectedTab;

    tabs = [
        { routeId: 1, text: 'TEAMS', url: '/', visible: false, allowedPermissions: [Permissions.manageUsers] },
        { routeId: 1, text: 'TEAMS', url: '/teams', visible: true, allowedPermissions: [Permissions.manageUsers, Permissions.manageTeams] },
        { routeId: 2, text: 'USERS', url: '/users', visible: true, allowedPermissions: [Permissions.manageUsers] },
        { routeId: 4, text: 'ROLES', url: '/roles', visible: true, allowedPermissions: [Permissions.manageRoles] },
        { routeId: 3, text: 'SETTINGS', url: '/settings/general', visible: true, allowedPermissions: [Permissions.manageSystemSettings, Permissions.manageAuthenticationProviders] },
        { routeId: 5, text: 'MY_PROFILE', url: '/profile', visible: true, allowedPermissions: [Permissions.allowAll] }
    ];

    @action setSelectedTab(selectedTab) {

        this.selectedTab = selectedTab;
    }

    @action setSelectedTabId(selectedTabId) {

        this.selectedTabId = selectedTabId;
    }

    @action setSelectedSecurityTab(tabid) {
        this.securitySelectedTab = tabid;
    }

    @action setSelectedGeneralSettingsTab(tabid) {
        this.generalSettingsSelectedTab = tabid;
    }
}

export default new RoutesStore();
